const skinVisualizer = () => {
    return {
        skinTypes: [],
        bodyParts: [],
        activeImage: "",
        activeCaption: "",
        visibleItemsDesktop: 16,
        visibleItemsMobile: 10,
        totalChildren: 0,
        showNoResults: false,
        showMoreResults: true,
        toggleShowMore: true,
        init() {
            this.getTotalChildren();
            this.checkShowMore();
        },
        getIsMobile() {
            let mobileMediaQuery = "(max-width: 475px)";
            let isMobile = window.matchMedia(mobileMediaQuery);
            return isMobile.matches;
        },
        checkShowMore(increment = 0) {
            let isMobile = this.getIsMobile();
            if (isMobile) {
                this.$nextTick(() => {
                    this.visibleItemsMobile += increment;
                    this.showMoreResults = this.visibleItemsMobile < this.totalChildren.length;
                });
            } else {
                this.$nextTick(() => {
                    this.visibleItemsDesktop += increment;
                    this.showMoreResults = this.visibleItemsDesktop < this.totalChildren.length;
                });
            }
        },
        getTotalChildren() {
            let allChildren = this.$refs.gallery.querySelectorAll(".galleryImage");
            this.totalChildren = Array.from(allChildren);
            this.$nextTick(() => {
                let countLimit = 5;
                // show no results text if total children = 0
                this.totalChildren.length === 0 ? (this.showNoResults = true) : (this.showNoResults = false);
                // hide bottom background if results < counterLimit
                this.totalChildren.length < countLimit ? this.$refs.skinVisualizer.classList.add("hideBottom") : this.$refs.skinVisualizer.classList.remove("hideBottom");
            });
        },

        showItem() {
            this.getTotalChildren();
            let isMobile = this.getIsMobile();
            let maxAmount = isMobile ? this.visibleItemsMobile : this.visibleItemsDesktop;

            return this.totalChildren.indexOf(this.$el) < maxAmount;
        },
        showImage(skinCategory, bodyCategory) {
            const isSkinFilterOff = this.skinTypes.length == 0;
            const isBodyFilterOff = this.bodyParts.length == 0;
            const isSkinFilterSelected = this.skinTypes.includes(skinCategory);
            const isBodyFilterSelected = this.bodyParts.includes(bodyCategory);

            if (isSkinFilterOff && isBodyFilterOff) {
                this.checkShowMore();
            }

            return (isSkinFilterOff && isBodyFilterOff) || (isSkinFilterOff && isBodyFilterSelected) || (isSkinFilterSelected && isBodyFilterOff) || (isSkinFilterSelected && isBodyFilterSelected);
        },
        resetVisibleItems() {
            this.visibleItemsDesktop = 16;
            this.visibleItemsMobile = 10;

            this.$nextTick(() => {
                this.getTotalChildren();
                this.checkShowMore();
            });
        },
        increaseVisibleItems() {
            let isMobile = this.getIsMobile();
            let incrementAmount = isMobile ? 2 : 8;
            this.checkShowMore(incrementAmount);
        },
        triggerEnter() {
            let elem = this.$el;
            elem.click();
        },
        launchModal() {
            $("#galleryModal").modal("show");
        },
        focusNextElement() {
            let elem = this.$el;
            if (elem.parentNode.nextElementSibling) elem.parentNode.nextElementSibling.querySelector("input").focus();
        },
        focusPrevElement() {
            let elem = this.$el;
            if (elem.parentNode.previousElementSibling) elem.parentNode.previousElementSibling.querySelector("input").focus();
        }
    };
};

export default skinVisualizer;
